import type { SVGProps } from "react";
import * as React from "react";
import { type iconSize, iconSizeVariants } from "@remi/types/icons";

type SvgIconProps = SVGProps<SVGSVGElement> & {
  size?: iconSize;
};
const Neutral = ({ size = "sm", ...props }: SvgIconProps) => {
  props.width = iconSizeVariants[size];
  props.height = iconSizeVariants[size];
  return (
    <svg {...props} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8 1.5C11.5896 1.50026 14.5 4.41031 14.5 8C14.4999 11.5896 11.5895 14.4997 8 14.5C4.41023 14.5 1.50013 11.5897 1.5 8C1.5 4.41015 4.41015 1.5 8 1.5ZM8 2.75C5.10051 2.75 2.75 5.10051 2.75 8C2.75013 10.8994 5.10059 13.25 8 13.25C10.8992 13.2497 13.2499 10.8992 13.25 8C13.25 5.10067 10.8993 2.75026 8 2.75ZM9.86621 10.123C10.1424 10.123 10.3662 10.3469 10.3662 10.623C10.3661 10.8991 10.1423 11.123 9.86621 11.123H6.13281C5.85675 11.123 5.63294 10.8991 5.63281 10.623C5.63281 10.3469 5.85667 10.123 6.13281 10.123H9.86621ZM5.97949 5.53516C6.25544 5.53529 6.47936 5.75921 6.47949 6.03516V7.03516C6.47949 7.31122 6.25552 7.53502 5.97949 7.53516C5.70356 7.53491 5.47949 7.31115 5.47949 7.03516V6.03516C5.47962 5.75928 5.70364 5.5354 5.97949 5.53516ZM10.0186 5.53516C10.2946 5.53516 10.5184 5.75913 10.5186 6.03516V7.03516C10.5186 7.3113 10.2947 7.53516 10.0186 7.53516C9.74273 7.53478 9.51855 7.31107 9.51855 7.03516V6.03516C9.51869 5.75936 9.74281 5.53553 10.0186 5.53516Z"
        fill="currentColor"
      />
    </svg>
  );
};
export default Neutral;
